module.exports = __webpack_public_path__ + "img/leakDetection.ad550be.svg";